import React from "react";

import testPDf from "../components/CV.pdf";
import Modals from "./modals";

const Main = () => {
  return (
    <div className="main">
      <section
        className="w-100 float-left service-con padding-top padding-bottom position-relative"
        id="service-con"
      >
        <div className="container">
          <div className="service-inner-con position-relative">
            <div className="generic-title text-center">
              <h6>My Expertise</h6>
              <h2 className="mb-0">
                Provide Wide Range of
                <br />
                Digital Services
              </h2>
            </div>
            <div className="service-box wow fadeInUp">
              <div className="row">
                <div className="col-lg-6 col-12">
                  <div className="service-box-item">
                    <figure className="mb-0">
                      <img
                        src="assets/image/service-icon3.png"
                        alt="service-icon"
                        className="img-fluid"
                      />
                    </figure>
                    <div className="service-box-item-content">
                      <h4>Web Development</h4>
                      <p>
                        Your websites are meant to make your business more
                        reachable. i provide users with one of the best user
                        experience using a wide range of tools
                      </p>
                      <a
                        href="#"
                        data-toggle="modal"
                        data-target="#web-development"
                      >
                        Read More
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-12">
                  <div className="service-box-item">
                    <figure className="mb-0">
                      <img
                        src="assets/image/service-icon2.png"
                        alt="service-icon"
                        className="img-fluid"
                      />
                    </figure>
                    <div className="service-box-item-content">
                      <h4>Web Design</h4>
                      <p>
                        Product lifecycle services from prototyping to product
                        support and everything in between, Iam looking forward
                        to your solutions.
                      </p>
                      <a href="#" data-toggle="modal" data-target="#web-design">
                        Read More
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mb-0">
                <div className="col-lg-6 col-12">
                  <div className="service-box-item mb-0">
                    <figure className="mb-0">
                      <img
                        src="assets/image/service-icon4.png"
                        alt="service-icon"
                        className="img-fluid"
                      />
                    </figure>
                    <div className="service-box-item-content">
                      <h4>Mobile App Development</h4>
                      <p>
                        As a full stack developer, i have really great ideas for
                        creating your Android or iOS application and i work hard
                        to turn them into reality.
                      </p>
                      <a
                        href="#"
                        data-toggle="modal"
                        data-target="#app-development"
                      >
                        Read More
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="w-100 float-left skill-con padding-top padding-bottom position-relative"
        id="about-con"
      >
        <div className="container">
          <div className="skill-inner-con position-relative">
            <div className="row">
              <div className="col-lg-6 order-lg-0 order-2">
                <div className="skill-left-con text-center wow slideInLeft">
                  <div className="row service-skill-sttaf-con">
                    <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                      <div className="skill-left-item-con">
                        <div className="circle-wrap firstPercentage">
                          <div className="circle">
                            <div className="mask full">
                              <div className="fill"></div>
                            </div>
                            <div className="mask half">
                              <div className="fill"></div>
                            </div>
                            <div className="inside-circle">
                              <div className="service-skill-sttaf-item-con">
                                <div className="service-skill-sttaf-item-title service-skill-sttaf-item1-con d-flex align-items-center justify-content-center">
                                  <h4 className="d-table-cell align-middle mb-0 text-center count">
                                    75
                                  </h4>
                                  <span className="static-txt2">%</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="service-skill-sttaf-item-heading">
                          <p className="mb-0">Mobile Application</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                      <div className="skill-left-item-con">
                        <div className="circle-wrap secondPercentage">
                          <div className="circle">
                            <div className="mask full">
                              <div className="fill"></div>
                            </div>
                            <div className="mask half">
                              <div className="fill"></div>
                            </div>
                            <div className="inside-circle">
                              <div className="service-skill-sttaf-item-con">
                                <div className="service-skill-sttaf-item-title service-skill-sttaf-item2-con text-center d-flex align-items-center justify-content-center">
                                  <h4 className=" mb-0 text-center count">
                                    95
                                  </h4>
                                  <span className=" static-txt2">%</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="service-skill-sttaf-item-heading">
                          <p className="mb-0">Web Designing</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row service-skill-sttaf-con">
                    <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                      <div className="skill-left-item-con">
                        <div className="circle-wrap thirdPercentage">
                          <div className="circle">
                            <div className="mask full">
                              <div className="fill"></div>
                            </div>
                            <div className="mask half">
                              <div className="fill"></div>
                            </div>
                            <div className="inside-circle">
                              <div className="service-skill-sttaf-item-con">
                                <div className="service-skill-sttaf-item-title service-skill-sttaf-item1-con d-flex align-items-center justify-content-center">
                                  <h4 className="d-table-cell align-middle mb-0 text-center count">
                                    85
                                  </h4>
                                  <span className="static-txt2">%</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="service-skill-sttaf-item-heading">
                          <p className="mb-0">Branding Design</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-6 col-12 ">
                      <div className="skill-left-item-con">
                        <div className="circle-wrap fourPercentage">
                          <div className="circle">
                            <div className="mask full">
                              <div className="fill"></div>
                            </div>
                            <div className="mask half">
                              <div className="fill"></div>
                            </div>
                            <div className="inside-circle">
                              <div className="service-skill-sttaf-item-con">
                                <div className="service-skill-sttaf-item-title service-skill-sttaf-item2-con text-center d-flex align-items-center justify-content-center">
                                  <h4 className=" mb-0 text-center count">
                                    80
                                  </h4>
                                  <span className=" static-txt2">%</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="service-skill-sttaf-item-heading">
                          <p className="mb-0">Web Development</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 d-flex align-items-center">
                <div className="skill-right-con wow slideInRight">
                  <h6>My Skills</h6>
                  <h2>Beautiful & Unique Digital Experiences</h2>
                  <p>
                    I provide with the best business software solutions using a
                    wide range of tools that help you get the best web portals
                    and application. My solutions are easy to use and easy to
                    maintain.
                  </p>
                  {/* <p>Quia voluptas sit aspernatur aut odit aut fugit, sed ruiano
                                        consequntar magni dolores.
                                    </p> */}
                  <div className="generic-btn download-bnt">
                    <a href={testPDf} download>
                      Download CV
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- skill section -->
            <!-- portfolio section --> */}

      <section
        id="resume"
        className="resume mt-4 mb-5"
        style={{ marginBottom: "113px!important" }}
      >
        <div className="container" data-aos="fade-up">
          <div className="section-title">
            <h2
              style={{
                borderBottom: "4px solid #6F34FE",
                width: "197px",
              }}
            >
              Resume
            </h2>
            {/* <p>Magnam dolores commodi suscipit. Necessitatibus eius consequatur ex aliquid fuga eum quidem. Sit sint consectetur velit. Quisquam quos quisquam cupiditate. Et nemo qui impedit suscipit alias ea. Quia fugiat sit in iste officiis commodi quidem hic quas.</p> */}
          </div>

          <div className="row">
            <div className="col-lg-6">
              <h3 className="resume-title">Sumary</h3>
              <div className="resume-item pb-0">
                {/* <h4>Alice Barkley</h4> */}
                <p>
                  <em>
                    Organized and dependable candidate successful at managing
                    multiple priorities with a positive attitude. Willingness to
                    take on added responsibilities to meet team goals. Talented
                    Computer Programmer brings 2+ years of experience delivering
                    error-free code within stringent deadlines. Comfortable with
                    Agile frameworks and working collaboratively or
                    autonomously.
                  </em>
                </p>
              </div>

              <h3 className="resume-title">Contact</h3>
              <div className="resume-item">
                <ul>
                  <li>
                    Flate No #4 block A18 rabia city Gulistan e Jauhar Karachi
                    Sindh Pakistan{" "}
                  </li>
                  <li>(+92) 3003929585</li>
                  <li>sajjadlaghari723@gmail.com</li>
                </ul>
                {/* <p>Qui deserunt veniam. Et sed aliquam labore tempore sed quisquam iusto autem sit. Ea vero voluptatum qui ut dignissimos deleniti nerada porti sand markend</p> */}
              </div>

              <h3 className="resume-title">Education</h3>
              <div className="resume-item">
                <h4>Bachelor of Computer Science </h4>
                <h5>2018 - 2021</h5>
                <p>
                  <em>University of Sindh, Jamshoro.</em>
                </p>
                {/* <p>Qui deserunt veniam. Et sed aliquam labore tempore sed quisquam iusto autem sit. Ea vero voluptatum qui ut dignissimos deleniti nerada porti sand markend</p> */}
              </div>
              <h3 className="resume-title">Certifications</h3>
              <div className="resume-item">
                <ul>
                  <li>
                    {" "}
                    <strong>
                      {" "}
                      AI and Data Science From MASS IT Training Program
                      (Saylani) Continue{" "}
                    </strong>
                  </li>
                  <li>
                    {" "}
                    <strong>
                      {" "}
                      CIT Six Month Course (certificate): At Hasnain Institute
                      of Information Technology Moro{" "}
                    </strong>
                  </li>
                  <li>
                    {" "}
                    <strong>
                      {" "}
                      6-Months Course CIT Web and Mobile App Development
                      (certificate): By NAVTACC at IMCS University of Sindh,
                      Jamshoro.{" "}
                    </strong>
                  </li>
                  <li>
                    {" "}
                    <strong>
                      {" "}
                      4-Months PHP-Basic with MYSQL Internship at Hidaya
                      Institute of Science and Technology Jamshoro.{" "}
                    </strong>
                  </li>
                  <li>
                    {" "}
                    <strong>
                      {" "}
                      3-Days training of trainers on ‘Life Changing’ on by New
                      Ora Tech Jamshoro.{" "}
                    </strong>
                  </li>
                </ul>
                {/* <p>Qui deserunt veniam. Et sed aliquam labore tempore sed quisquam iusto autem sit. Ea vero voluptatum qui ut dignissimos deleniti nerada porti sand markend</p> */}
              </div>
              {/* <div className="resume-item">
              <h4>Bachelor of Fine Arts &amp; Graphic Design</h4>
              <h5>2010 - 2014</h5>
              <p><em>Rochester Institute of Technology, Rochester, NY</em></p>
              <p>Quia nobis sequi est occaecati aut. Repudiandae et iusto quae reiciendis et quis Eius vel ratione eius unde vitae rerum voluptates asperiores voluptatem Earum molestiae consequatur neque etlon sader mart dila</p>
            </div> */}
            </div>
            <div className="col-lg-6">
              <h3 className="resume-title">Professional Experience</h3>

              <div className="resume-item">
                <p>
                  <h4>
                    I have been working as a Laravel Developer for TeamX
                    Pakistan for 2 months, as well as working as a freelancer
                  </h4>
                  <h4>Laravel Developer</h4>
                  <h5>2022 - Present</h5>
                  <p>
                    <em>Karachi Sindhi Pakistan</em>
                  </p>
                </p>
              </div>
              <div className="resume-item">
                <h4>
                  I worked as a Full Stack Developer for Fugen Services for six
                  months.
                </h4>
                <h5>June - Nov 2022</h5>
                <p>
                  <em>Karachi Sindhi Pakistan </em>
                </p>
                <p>
                  {/* <ul>
                <li>Lead in the design, development, and implementation of the graphic, layout, and production communication materials</li>
                <li>Delegate tasks to the 7 members of the design team and provide counsel on all aspects of the project. </li>
                <li>Supervise the assessment of all graphic materials in order to ensure quality and accuracy of the design</li>
                <li>Oversee the efficient use of production project budgets ranging from $2,000 - $25,000</li>
              </ul> */}
                </p>
              </div>

              <h3 className="resume-title">Expertise</h3>
              <div className="resume-item">
                <ul className="list-unstyled">
                  <li>
                    {" "}
                    <h5>HTML,CSS, Bootstrap ,Javascript, Jquery</h5>
                  </li>
                  <li>
                    <h5>Laravel,PHP, Ajax,MYSQL Daatbase </h5>
                  </li>
                  <li>
                    <h5>Reactjs, mongoDB, ReactNative </h5>
                  </li>
                  <li>
                    <h5>
                      Python Django loding !... AI and Data Science Engineer{" "}
                    </h5>
                  </li>
                </ul>
                {/* <p>Qui deserunt veniam. Et sed aliquam labore tempore sed quisquam iusto autem sit. Ea vero voluptatum qui ut dignissimos deleniti nerada porti sand markend</p> */}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section
        className="w-100 float-left portfolio-con "
        id="Portfolio"
        style={{ paddingTop: "58px" }}
      >
        <div className="container">
          <div className="generic-title text-center">
            <h6 className="text-white">Creative Works</h6>
            <h2 className="mb-0 text-white">Check My Portfolio</h2>
          </div>
        </div>
        <section className="w-100 float-left blog-con padding-top padding-bottom position-relative">
          <div className="container">
            <div className="blog-inner-con position-relative">
              <div className="blog-box wow fadeInUp">
                <div className="row">
                  <div className="col-lg-4">
                    <div className="blog-box-item">
                      <div className="blog-img">
                        <a
                          href="#"
                          data-toggle="modal"
                          data-target="#blog-model-reactjs"
                        >
                          <figure className="mb-0">
                            <img
                              src="assets/image/reactjs.png"
                              alt="blog-img"
                              className="img-fluid"
                            />
                          </figure>
                        </a>
                      </div>
                      <div className="blog-content">
                        <div className="blog-auteher-title">
                          <span>By Sajjad Ali</span>
                          {/* <span className="float-lg-right">Mar 8, 2022</span> */}
                        </div>
                        <a
                          href="#"
                          data-toggle="modal"
                          data-target="#blog-model-reactjs"
                        >
                          <h4>Website Using React Js Library</h4>
                        </a>
                        {/* <p>Dolor repellendus temporibus autem
                                                    quibusdam officiis debitis rerum nece
                                                    aibus minima veniam.
                                                </p> */}
                        <a
                          href="#"
                          data-toggle="modal"
                          data-target="#blog-model-reactjs"
                        >
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="blog-box-item">
                      <div className="blog-img">
                        <a
                          href="#"
                          data-toggle="modal"
                          data-target="#model-mobile-screen-website"
                        >
                          <figure className="mb-0">
                            <img
                              src="assets/image/Mobile-Design.png"
                              alt="blog-img"
                              className="img-fluid"
                              style={{ height: "320px" }}
                            />
                          </figure>
                        </a>
                      </div>
                      <div className="blog-content">
                        <div className="blog-auteher-title">
                          <span>By Sajjad Ali</span>
                          {/* <span className="float-lg-right">Mar 9, 2022</span> */}
                        </div>
                        <a
                          href="#"
                          data-toggle="modal"
                          data-target="#model-mobile-screen-website"
                        >
                          <h4>Mobile Application Design React Native Hybrid</h4>
                        </a>
                        <a
                          href="#"
                          data-toggle="modal"
                          data-target="#model-mobile-screen-website"
                        >
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="blog-box-item mb-0">
                      <div className="blog-img">
                        <a
                          href="#"
                          data-toggle="modal"
                          data-target="#mobile-app-modal"
                        >
                          <figure className="mb-0">
                            <img
                              src="assets/image/mobileapp.png"
                              alt="blog-img"
                              className="img-fluid"
                            />
                          </figure>
                        </a>
                      </div>
                      <div className="blog-content">
                        <div className="blog-auteher-title">
                          <span>By Sajjad Ali</span>
                          <span className="float-lg-right">Jul 10, 2022</span>
                        </div>
                        <a
                          href="#"
                          data-toggle="modal"
                          data-target="#mobile-app-modal"
                        >
                          <h4>Mobile Application Using React Native </h4>
                        </a>
                        {/* <p>Dolor repellendus temporibus autem
                                                    quibusdam officiis debitis rerum nece
                                                    aibus minima veniam.
                                                </p> */}
                        <a
                          href="#"
                          data-toggle="modal"
                          data-target="#mobile-app-modal"
                        >
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="blog-box wow fadeInUp mt-5">
                <div className="row">
                  <div className="col-lg-4">
                    <div className="blog-box-item">
                      <div className="blog-img">
                        <a
                          href="#"
                          data-toggle="modal"
                          data-target="#online-blogging-application"
                        >
                          <figure className="mb-0">
                            <img
                              src="assets/image/blogging.png"
                              alt="blog-img"
                              className="img-fluid"
                            />
                          </figure>
                        </a>
                      </div>
                      <div className="blog-content">
                        <div className="blog-auteher-title">
                          <span>By Sajjad Ali</span>
                          {/* <span className="float-lg-right">Mar 8, 2022</span> */}
                        </div>
                        <a
                          href="#"
                          data-toggle="modal"
                          data-target="#online-blogging-application"
                        >
                          <h4>Online Blogging Application Using Core PHP</h4>
                        </a>
                        {/* <p>Dolor repellendus temporibus autem
                                                    quibusdam officiis debitis rerum nece
                                                    aibus minima veniam.
                                                </p> */}
                        <a
                          href="#"
                          data-toggle="modal"
                          data-target="#online-blogging-application"
                        >
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="blog-box-item">
                      <div className="blog-img">
                        <a
                          href="#"
                          data-toggle="modal"
                          data-target="#model-laravel-website"
                        >
                          <figure className="mb-0">
                            <img
                              src="assets/image/laravelHos.png"
                              alt="blog-img"
                              className="img-fluid"
                            />
                          </figure>
                        </a>
                      </div>
                      <div className="blog-content">
                        <div className="blog-auteher-title">
                          <span>By Sajjad Ali</span>
                          {/* <span className="float-lg-right">Mar 9, 2022</span> */}
                        </div>
                        <a
                          href="#"
                          data-toggle="modal"
                          data-target="#model-laravel-website"
                        >
                          <h4>Web Application Using Laravel Framework</h4>
                        </a>
                        <a
                          href="#"
                          data-toggle="modal"
                          data-target="#model-laravel-website"
                        >
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="blog-box-item mb-0">
                      <div className="blog-img">
                        <a
                          href="#"
                          data-toggle="modal"
                          data-target="#blog-model-3"
                        >
                          <figure className="mb-0">
                            <img
                              src="assets/image/mobileapp.png"
                              alt="blog-img"
                              className="img-fluid"
                            />
                          </figure>
                        </a>
                      </div>
                      <div className="blog-content">
                        <div className="blog-auteher-title">
                          <span>By Sajjad Ali</span>
                          <span className="float-lg-right">June 23, 2022</span>
                        </div>
                        <a
                          href="#"
                          data-toggle="modal"
                          data-target="#blog-model-3"
                        >
                          <h4>Mobile Application Using React Native </h4>
                        </a>
                        {/* <p>Dolor repellendus temporibus autem
                                                    quibusdam officiis debitis rerum nece
                                                    aibus minima veniam.
                                                </p> */}
                        <a
                          href="#"
                          data-toggle="modal"
                          data-target="#blog-model-3"
                        >
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="blog-box wow fadeInUp mt-5">
                <div className="row">
                  <div className="col-lg-4">
                    <div className="blog-box-item">
                      <div className="blog-img">
                        <a
                          href="#"
                          data-toggle="modal"
                          data-target="#model-django"
                        >
                          <figure className="mb-0">
                            <img
                              src="assets/image/ecomdjang.png"
                              alt="blog-img"
                              className="img-fluid"
                            />
                          </figure>
                        </a>
                      </div>
                      <div className="blog-content">
                        <div className="blog-auteher-title">
                          <span>By Sajjad Ali</span>
                          {/* <span className="float-lg-right">Mar 8, 2022</span> */}
                        </div>
                        <a
                          href="#"
                          data-toggle="modal"
                          data-target="#model-django"
                        >
                          <h4>E-Commerce With Python Django Framework</h4>
                        </a>
                        {/* <p>Dolor repellendus temporibus autem
                                                    quibusdam officiis debitis rerum nece
                                                    aibus minima veniam.
                                                </p> */}
                        <a
                          href="#"
                          data-toggle="modal"
                          data-target="#model-django"
                        >
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="blog-box-item">
                      <div className="blog-img">
                        <a
                          href="#"
                          data-toggle="modal"
                          data-target="#ecommerce-reactjs"
                        >
                          <figure className="mb-0">
                            <img
                              src="assets/image/ecomeedjngo.png"
                              alt="blog-img"
                              className="img-fluid"
                            />
                          </figure>
                        </a>
                      </div>
                      <div className="blog-content">
                        <div className="blog-auteher-title">
                          <span>By Sajjad Ali</span>
                          {/* <span className="float-lg-right">Mar 9, 2022</span> */}
                        </div>
                        <a
                          href="#"
                          data-toggle="modal"
                          data-target="#ecommerce-reactjs"
                        >
                          <h4>E-Commerce App in React Js</h4>
                        </a>
                        <a
                          href="#"
                          data-toggle="modal"
                          data-target="#ecommerce-reactjs"
                        >
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="blog-box-item mb-0">
                      <div className="blog-img">
                        <a
                          href="#"
                          data-toggle="modal"
                          data-target="#blog-model-discord"
                        >
                          <figure className="mb-0">
                            <img
                              src="assets/image/discord.png"
                              alt="blog-img"
                              className="img-fluid"
                            />
                          </figure>
                        </a>
                      </div>
                      <div className="blog-content">
                        <div className="blog-auteher-title">
                          <span>By Sajjad Ali</span>
                          <span className="float-lg-right">May 10, 2022</span>
                        </div>
                        <a
                          href="#"
                          data-toggle="modal"
                          data-target="#blog-model-discord"
                        >
                          <h4>Discor type Application </h4>
                        </a>
                        {/* <p>Dolor repellendus temporibus autem
                                                    quibusdam officiis debitis rerum nece
                                                    aibus minima veniam.
                                                </p> */}
                        <a
                          href="#"
                          data-toggle="modal"
                          data-target="#blog-model-discord"
                        >
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>

      {/* <!-- portfolio section -->
            <!-- portfolio section --> */}
      <section className="w-100 float-left portfolio-body-con">
        <div className="container">
          <div className="portfolio-img-con position-relative w-100 float-left wow fadeInUp">
            <div className="filterDiv cars position-relative">
              <a href="#" data-toggle="modal" data-target="#modalWPWAF">
                <div className="portfolio-img position-relative">
                  <figure>
                    <img
                      src="assets/image/portfolio-img1.png"
                      alt="portfolio-img1"
                      className="img-fluid"
                    />
                  </figure>
                </div>
              </a>
              <div className="portfolio-img-content text-left">
                <div className="portfolio-img-title d-inline-block">
                  <h4>Application UI Design</h4>
                  <p>Dolar repellendus temporibus...</p>
                </div>
                <a
                  href="#"
                  className="float-lg-right"
                  data-toggle="modal"
                  data-target="#modalWPWAF-icon"
                >
                  <i className="fas fa-arrow-right d-flex align-items-center justify-content-center"></i>
                </a>
              </div>
            </div>
            <div className="filterDiv colors fruits position-relative">
              <a href="#" data-toggle="modal" data-target="#modalporfolio2">
                <div className="portfolio-img position-relative">
                  <figure>
                    <img
                      src="assets/image/portfolio-img2.png"
                      alt="portfolio-img1"
                      className="img-fluid"
                    />
                  </figure>
                </div>
              </a>
              <div className="portfolio-img-content text-left">
                <div className="portfolio-img-title d-inline-block">
                  <h4>Furni furniture UI Design</h4>
                  <p>Dolar repellendus temporibus...</p>
                </div>
                <a
                  href="#"
                  className="float-lg-right"
                  data-toggle="modal"
                  data-target="#modalporfolio2-icon"
                >
                  <i className="fas fa-arrow-right d-flex align-items-center justify-content-center"></i>
                </a>
              </div>
            </div>
            <div className="filterDiv cars position-relative">
              <a href="#" data-toggle="modal" data-target="#modalporfolio3">
                <div className="portfolio-img position-relative">
                  <figure>
                    <img
                      src="assets/image/portfolio-img3.png"
                      alt="portfolio-img1"
                      className="img-fluid"
                    />
                  </figure>
                </div>
              </a>
              <div className="portfolio-img-content text-left">
                <div className="portfolio-img-title d-inline-block">
                  <h4>Mobile UI Design</h4>
                  <p>Dolar repellendus temporibus...</p>
                </div>
                <a
                  href="#"
                  className="float-lg-right"
                  data-toggle="modal"
                  data-target="#modalporfolio3-icon"
                >
                  <i className="fas fa-arrow-right d-flex align-items-center justify-content-center"></i>
                </a>
              </div>
            </div>
            <div className="filterDiv colors position-relative">
              <a href="#" data-toggle="modal" data-target="#modalporfolio4">
                <div className="portfolio-img position-relative">
                  <figure>
                    <img
                      src="assets/image/portfolio-img4.png"
                      alt="portfolio-img1"
                      className="img-fluid"
                    />
                  </figure>
                </div>
              </a>
              <div className="portfolio-img-content text-left">
                <div className="portfolio-img-title d-inline-block">
                  <h4>Businesscard UI Design</h4>
                  <p>Dolar repellendus temporibus...</p>
                </div>
                <a
                  href="#"
                  className="float-lg-right"
                  data-toggle="modal"
                  data-target="#modalporfolio4-icon"
                >
                  <i className="fas fa-arrow-right d-flex align-items-center justify-content-center"></i>
                </a>
              </div>
            </div>
            <div className="filterDiv cars animals position-relative">
              <a href="#" data-toggle="modal" data-target="#modalporfolio5">
                <div className="portfolio-img position-relative">
                  <figure>
                    <img
                      src="assets/image/portfolio-img5.png"
                      alt="portfolio-img1"
                      className="img-fluid"
                    />
                  </figure>
                </div>
              </a>
              <div className="portfolio-img-content text-left">
                <div className="portfolio-img-title d-inline-block">
                  <h4>Real estate UI Design</h4>
                  <p>Dolar repellendus temporibus...</p>
                </div>
                <a
                  href="#"
                  className="float-lg-right"
                  data-toggle="modal"
                  data-target="#modalporfolio5-icon"
                >
                  <i className="fas fa-arrow-right d-flex align-items-center justify-content-center"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- portfolio section -->
            <!-- tastimonials section --> */}
      {/* <section
        className="w-100 float-left padding-top padding-bottom tastimonials-con position-relative text-lg-left text-center"
        id="testimonials"
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-5">
              <div className="tastimonials-left-con wow slideInLeft">
                <figure className="mb-0">
                  <img
                    src="assets/image/tastimonials-img.png"
                    alt="tastimonials-img"
                    className="img-fluid"
                  />
                </figure>
              </div>
            </div>
            <div className="col-lg-7">
              <div
                id="carouselExampleControls"
                className="carousel slide wow slideInRight"
                data-ride="carousel"
              >
                <div className="carousel-inner">
                  <div className="carousel-item active">
                    <div className="testimonials-content">
                      <h6>Testimonials</h6>
                      <h2>Happy Clients Feedback</h2>
                      <figure className="mb-0">
                        <img
                          src="assets/image/comma-icon.png"
                          alt="comma-icon"
                          className="img-fluid"
                        />
                      </figure>
                      <div className="testimonials-inner-content">
                        <p>
                          It is a long established fact that a reader will be
                          distracted by the readable content of a page when
                          looking at its layout. The point of using Lorem Ipsum
                          is that it has a more-or-less normal distribution of
                          letters, as opposed to using 'Content here, content
                          here', making it look like readable English. Many
                          desktop publishing packages and web page editors now
                          use Lorem Ipsum as their default model text, and a
                          search for 'lorem ipsum' will uncover many web sites
                          still in their infancy. Various versions have evolved
                          over the years, sometimes by accident, sometimes on
                          purpose (injected humour and the like).
                        </p>
                        <span className="d-block auther-name">
                          Kevin Andrew
                        </span>
                        <span className="d-block">CEO of the company</span>
                      </div>
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="testimonials-content">
                      <h6>Testimonials</h6>
                      <h2>Happy Clients Feedback</h2>
                      <figure className="mb-0">
                        <img
                          src="assets/image/comma-icon.png"
                          alt="comma-icon"
                          className="img-fluid"
                        />
                      </figure>
                      <div className="testimonials-inner-content">
                        <p>
                          It is a long established fact that a reader will be
                          distracted by the readable content of a page when
                          looking at its layout. The point of using Lorem Ipsum
                          is that it has a more-or-less normal distribution of
                          letters, as opposed to using 'Content here, content
                          here', making it look like readable English. Many
                          desktop publishing packages and web page editors now
                          use Lorem Ipsum as their default model text, and a
                          search for 'lorem ipsum' will uncover many web sites
                          still in their infancy. Various versions have evolved
                          over the years, sometimes by accident, sometimes on
                          purpose (injected humour and the like).
                        </p>
                        <span className="d-block auther-name">
                          Kevin Andrew
                        </span>
                        <span className="d-block">CEO of the company</span>
                      </div>
                    </div>
                  </div>
                  <div className="carousel-item">
                    <div className="testimonials-content">
                      <h6>Testimonials</h6>
                      <h2>Happy Clients Feedback</h2>
                      <figure className="mb-0">
                        <img
                          src="assets/image/comma-icon.png"
                          alt="comma-icon"
                          className="img-fluid"
                        />
                      </figure>
                      <div className="testimonials-inner-content">
                        <p>
                          It is a long established fact that a reader will be
                          distracted by the readable content of a page when
                          looking at its layout.
                        </p>
                        <span className="d-block auther-name">
                          Kevin Andrew
                        </span>
                        <span className="d-block">CEO of the company</span>
                      </div>
                    </div>
                  </div>
                </div>
                <a
                  className="carousel-control-prev"
                  href="#carouselExampleControls"
                  role="button"
                  data-slide="prev"
                >
                  <i className="fas fa-arrow-left d-flex align-items-center justify-content-center"></i>
                  <span className="sr-only">Previous</span>
                </a>
                <a
                  className="carousel-control-next"
                  href="#carouselExampleControls"
                  role="button"
                  data-slide="next"
                >
                  <i className="fas fa-arrow-right d-flex align-items-center justify-content-center"></i>
                  <span className="sr-only">Next</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      {/* <!-- tastimonials section -->
            <!-- blog section --> */}
      {/* <section
        className="w-100 float-left blog-con padding-top padding-bottom position-relative"
        id="blog"
      >
        <div className="container">
          <div className="blog-inner-con position-relative">
            <div className="generic-title text-center">
              <h6>Latest News</h6>
              <h2 className="mb-0">Blog & Articles</h2>
            </div>
            <div className="blog-box wow fadeInUp">
              <div className="row">
                <div className="col-lg-4">
                  <div className="blog-box-item">
                    <div className="blog-img">
                      <a
                        href="#"
                        data-toggle="modal"
                        data-target="#blog-model-1"
                      >
                        <figure className="mb-0">
                          <img
                            src="assets/image/blog-img-1.png"
                            alt="blog-img"
                            className="img-fluid"
                          />
                        </figure>
                      </a>
                    </div>
                    <div className="blog-content">
                      <div className="blog-auteher-title">
                        <span>By David William</span>
                        <span className="float-lg-right">Mar 8, 2022</span>
                      </div>
                      <a
                        href="#"
                        data-toggle="modal"
                        data-target="#blog-model-1"
                      >
                        <h4>Quis autem vea eum iure reprehenderit</h4>
                      </a>
                      <p>
                        Dolor repellendus temporibus autem quibusdam officiis
                        debitis rerum nece aibus minima veniam.
                      </p>
                      <a
                        href="#"
                        data-toggle="modal"
                        data-target="#blog-model-1"
                      >
                        Read More
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="blog-box-item">
                    <div className="blog-img">
                      <a
                        href="#"
                        data-toggle="modal"
                        data-target="#blog-model-2"
                      >
                        <figure className="mb-0">
                          <img
                            src="assets/image/blog-img-2.png"
                            alt="blog-img"
                            className="img-fluid"
                          />
                        </figure>
                      </a>
                    </div>
                    <div className="blog-content">
                      <div className="blog-auteher-title">
                        <span>By John Doe</span>
                        <span className="float-lg-right">Mar 9, 2022</span>
                      </div>
                      <a
                        href="#"
                        data-toggle="modal"
                        data-target="#blog-model-2"
                      >
                        <h4>Reprehenderit in vouta velit esse cillum</h4>
                      </a>
                      <p>
                        Dolor repellendus temporibus autem quibusdam officiis
                        debitis rerum nece aibus minima veniam.
                      </p>
                      <a
                        href="#"
                        data-toggle="modal"
                        data-target="#blog-model-2"
                      >
                        Read More
                      </a>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="blog-box-item mb-0">
                    <div className="blog-img">
                      <a
                        href="#"
                        data-toggle="modal"
                        data-target="#blog-model-3"
                      >
                        <figure className="mb-0">
                          <img
                            src="assets/image/blog-img-3.png"
                            alt="blog-img"
                            className="img-fluid"
                          />
                        </figure>
                      </a>
                    </div>
                    <div className="blog-content">
                      <div className="blog-auteher-title">
                        <span>By Elina Parker</span>
                        <span className="float-lg-right">Mar 10, 2022</span>
                      </div>
                      <a
                        href="#"
                        data-toggle="modal"
                        data-target="#blog-model-3"
                      >
                        <h4>Soluta nobis ose aligen optio cumue</h4>
                      </a>
                      <p>
                        Dolor repellendus temporibus autem quibusdam officiis
                        debitis rerum nece aibus minima veniam.
                      </p>
                      <a
                        href="#"
                        data-toggle="modal"
                        data-target="#blog-model-3"
                      >
                        Read More
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      {/* <!-- blog section -->
            <!-- form section --> */}
      <section
        className="w-100 float-left form-main-con padding-top padding-bottom"
        id="Contact"
      >
        <div className="container">
          <div className="form-main-inner-con position-relative">
            <div className="generic-title text-center">
              <h6>Get in Touch</h6>
              <h2 className="mb-0">
                Any Questions? Feel Free
                <br />
                to Contact
              </h2>
            </div>
            <div className="row">
              <div className="col-lg-4 order-lg-0 order-2">
                <div className="contact-information position-relative wow slideInLeft">
                  <ul className="list-unstyled">
                    <li>
                      <figure className="mb-0 d-flex align-items-center justify-content-center">
                        <img
                          src="assets/image/location-icon.png"
                          alt="location-icon"
                          className="img-fluid"
                        />
                      </figure>
                      <div className="contact-information-content">
                        <h5>Address:</h5>
                        <p className="mb-0">
                          Flate No #4 block A18 rabia city Gulistan e Jauhar
                          Karachi Sindh Pakistan
                        </p>
                      </div>
                    </li>
                    <li>
                      <figure className="mb-0 d-flex align-items-center justify-content-center">
                        <img
                          src="assets/image/message-icon.png"
                          alt="message-icon"
                          className="img-fluid"
                        />
                      </figure>
                      <div className="contact-information-content">
                        <h5>Email:</h5>
                        <p className="mb-0">sajjadlaghari723@gmail.com</p>
                        {/* <p className="mb-0">folioflix@gmail.com</p> */}
                      </div>
                    </li>
                    <li className="mb-0">
                      <figure className="mb-0 d-flex align-items-center justify-content-center">
                        <img
                          src="assets/image/phone-icon.png"
                          alt="phone-icon"
                          className="img-fluid"
                        />
                      </figure>
                      <div className="contact-information-content">
                        <h5>Phone:</h5>
                        <p className="mb-0">+92 3003929585</p>
                        <p className="mb-0">+92 3126995341</p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-8">
                <div id="form_result"></div>

                <form
                  id="contactpage"
                  method="POST"
                  className="contact-form wow slideInRight text-lg-left text-center"
                >
                  <div className="row">
                    <div className="col-lg-6 col-md-6">
                      <div className="form-group mb-0">
                        <input
                          type="text"
                          placeholder="Name"
                          name="name"
                          id="name"
                          autocomplete="off"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="form-group mb-0">
                        <input
                          type="email"
                          id="emailHelp"
                          name="emailHelp"
                          placeholder="Email"
                          autocomplete="off"
                          required
                        />
                        <small className="form-text text-muted"></small>
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="form-group mb-0">
                        <input
                          type="tel"
                          placeholder="Phone"
                          name="phone"
                          id="phone"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-6">
                      <div className="form-group mb-0">
                        <input
                          type="text"
                          name="subject"
                          placeholder="Subject"
                          id="subject"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12">
                      <div className=" form-group mb-0">
                        <textarea
                          placeholder="Message"
                          rows="3"
                          name="comments"
                          id="comments"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <button type="submit" id="submit" className="appointment-btn">
                    Submit
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- form section --> */}
      {/* <!-- weight footer section --> */}
      <div className="w-100 float-left weight-footer-con position-relative">
        <div className="container">
          <div className="weight-footer-content text-center wow fadeInUp">
            <figure className="">
              <h2 className="text-white">Sajjad Ali</h2>
            </figure>
            <div className="footer-navbar">
              <ul className="list-unstyled">
                <li className="d-inline-block border-left-0 pl-0">
                  <a href="#home">Home</a>
                </li>
                <li className="d-inline-block">
                  <a href="#about-con">About</a>
                </li>
                <li className="d-inline-block">
                  <a href="#service-con">Services</a>
                </li>
                <li className="d-inline-block">
                  <a href="#Portfolio">Portfolio</a>
                </li>
                <li className="d-inline-block pr-0">
                  <a href="#Contact">Contact</a>
                </li>
              </ul>
            </div>
            <div className="footer-social-icon">
              <ul className="mb-0">
                <li className="d-inline-block">
                  <a href="https://wa.me/00923003929585">
                    <i className="fab fa-whatsapp d-flex align-items-center justify-content-center"></i>
                  </a>
                </li>

                <li className="d-inline-block">
                  <a href="https://www.linkedin.com/in/sajjad-laghari-59673921b/">
                    <i className="fab fa-linkedin-in d-flex align-items-center justify-content-center"></i>
                  </a>
                </li>

                <li className="d-inline-block">
                  {" "}
                  <a href="https://www.fiverr.com/users/creationcue/seller_dashboard">
                    <img src="assets/image/fiverr_logo_icon_169172.png" />
                  </a>
                </li>

                <li className="d-inline-block " style={{ maefinLeft: "10px" }}>
                  <a href="https://www.upwork.com/freelancers/~0121c3f7eb8808f732">
                    <img
                      src="assets/image/upwork_logo_icon_170310.png"
                      style={{ width: "50px", marginRight: "5px" }}
                    />
                  </a>
                </li>

                <li className="d-inline-block ">
                  <a href="https://github.com/Sajjadlaghari">
                    <i className="fab fa-github d-flex align-items-center justify-content-center"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="copy-right-content text-center">
            <p className="mb-0">
              Copyright 2022 Sajjad Ali | All Rights Reserved.
            </p>
          </div>
        </div>
      </div>
      <a id="button"></a>

      <Modals />
    </div>
  );
};

export default Main;
